<template>
	<svg :class="classes" width="127" height="48" viewBox="0 0 127 64" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M110.705 19.8414C114.797 19.8414 117.246 22.605 117.336 26.2699H104.066C104.178 22.7702 106.965 19.8414 110.697 19.8414H110.705ZM120.182 36.0178C117.741 37.6024 114.85 38.5187 111.726 38.5187C107.573 38.5187 104.111 36.123 104.088 32.5632V31.7371H123.607C126.663 31.7371 126.783 28.9359 126.641 27.1335C125.792 16.8824 119.281 11.3851 110.322 11.4302C101.46 11.4302 93.5517 18.7374 93.5517 29.2589C93.5517 40.9369 101.295 46.8923 111.628 46.8923C116.728 46.8923 121.376 44.797 124.711 41.4175C125.747 40.4112 126.235 38.4511 125.116 36.904C123.997 35.3645 122.03 34.8988 120.175 36.0103L120.182 36.0178Z" fill="#0048BC" style="fill:#0048BC;fill:color(display-p3 0.0000 0.2824 0.7373);fill-opacity:1;"/>
		<path d="M16.8674 37.9254C13.4579 37.9254 10.8294 34.8538 10.8294 29.1687C10.8294 23.4837 13.4579 20.4121 16.8674 20.4121C20.2769 20.4121 22.9054 23.4837 22.9054 29.1687C22.9054 34.8538 20.2769 37.9254 16.8674 37.9254ZM16.8674 11.4302C7.35226 11.4302 0 17.6559 0 29.1687C0 40.6815 7.35977 46.9073 16.8674 46.9073C26.375 46.9073 33.7348 40.6815 33.7348 29.1687C33.7348 17.6559 26.375 11.4302 16.8674 11.4302Z" fill="#0048BC" style="fill:#0048BC;fill:color(display-p3 0.0000 0.2824 0.7373);fill-opacity:1;"/>
		<path d="M54.8679 37.9254C51.4583 37.9254 48.8298 34.8538 48.8298 29.1687C48.8298 23.4837 51.4583 20.4121 54.8679 20.4121C58.2774 20.4121 60.9059 23.4837 60.9059 29.1687C60.9059 34.8538 58.2774 37.9254 54.8679 37.9254ZM58.5778 11.4302C54.6576 11.4302 51.2105 13.165 48.8298 16.4919V14.5769C48.8298 13.1425 47.6733 11.9859 46.2389 11.9859H34.9814C32.9538 11.9859 32.413 13.3527 32.413 13.901C32.413 17.0476 37.993 17.0176 37.993 20.1267V55.8592C37.993 58.9758 32.413 58.9308 32.413 62.085C32.413 62.6257 32.9538 64 34.9814 64H51.8338C53.8615 64 54.4023 62.6332 54.4023 62.085C54.4023 58.9383 48.8223 58.9683 48.8223 55.8592V41.823C51.203 45.15 54.6501 46.8848 58.5703 46.8848C65.9976 46.8848 71.7353 40.659 71.7353 29.1462C71.7353 17.6334 65.9976 11.4077 58.5703 11.4077V11.4302H58.5778Z" fill="#0048BC" style="fill:#0048BC;fill:color(display-p3 0.0000 0.2824 0.7373);fill-opacity:1;"/>
		<path d="M111.628 0C103.074 0 91.6667 11.6705 87.6639 17.1903V14.5769C87.6639 13.1425 86.5074 11.9859 85.073 11.9859H73.8155C71.7878 11.9859 71.2471 13.3527 71.2471 13.901C71.2471 17.0476 76.827 17.0176 76.827 20.1267V38.1882C76.827 41.3049 71.2471 41.2598 71.2471 44.414C71.2471 44.9547 71.7878 46.329 73.8155 46.329H90.6679C92.6956 46.329 93.2363 44.9622 93.2363 44.414C93.2363 41.2673 87.6564 41.2974 87.6564 38.1882V28.8834C87.6564 19.5485 100.649 7.3748 106.409 7.3748C108.669 7.3748 109.796 8.54635 111.628 8.54635C113.986 8.54635 115.901 6.63131 115.901 4.27318C115.901 1.91505 113.986 0 111.628 0Z" fill="#0048BC" style="fill:#0048BC;fill:color(display-p3 0.0000 0.2824 0.7373);fill-opacity:1;"/>
	</svg>
</template>

<script>
export default {
	name: "DuoToneTeamingWordLogo",
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"teaming-letter-logo": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>


<style lang="scss" scoped>
.duoToneTeamingWordLogo__Path {
	&:first-of-type {
		fill: $duo-tone-teaming-word-color1;
	}

	&:last-of-type {
		fill: $duo-tone-teaming-word-color2;
	}
}
</style>
